'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _DeforestationSectors = require('./DeforestationSectors.css');

var _DeforestationSectors2 = _interopRequireDefault(_DeforestationSectors);

var _components = require('../../components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeforestationSectors = (_dec = (0, _reactCssModules2.default)(_DeforestationSectors2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(DeforestationSectors, _Component);

  function DeforestationSectors(props) {
    (0, _classCallCheck3.default)(this, DeforestationSectors);
    return (0, _possibleConstructorReturn3.default)(this, (DeforestationSectors.__proto__ || (0, _getPrototypeOf2.default)(DeforestationSectors)).call(this, props));
  }

  (0, _createClass3.default)(DeforestationSectors, [{
    key: 'render',
    value: function render() {
      var producersIcon = require('../../../static/images/icn-producers.svg');
      var banksIcon = require('../../../static/images/icn-banks.svg');
      var consumersIcon = require('../../../static/images/icn-consumers.svg');
      var poIcon = require('../../../static/images/icn-po.svg');
      var ppIcon = require('../../../static/images/icn-pp.svg');
      var rbIcon = require('../../../static/images/icn-rb.svg');
      var tbIcon = require('../../../static/images/icn-tb.svg');
      var bfIcon = require('../../../static/images/icn-bf.svg');
      var syIcon = require('../../../static/images/icn-sy.svg');
      return _react2.default.createElement(
        'div',
        { styleName: 'sectors-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'sectors' },
          _react2.default.createElement(
            'div',
            { styleName: 'sectors-inner' },
            _react2.default.createElement(
              'div',
              { styleName: 'sectors-title' },
              'Deforestation-risk companies'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { styleName: 'detail-icon-producers-wrap', xs: 4, sm: 2 },
                _react2.default.createElement('img', {
                  styleName: 'detail-icon-producers',
                  src: poIcon,
                  alt: 'Palm oil'
                }),
                'Palm oil'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { styleName: 'detail-icon-producers-wrap', xs: 4, sm: 2 },
                _react2.default.createElement('img', {
                  styleName: 'detail-icon-producers',
                  src: ppIcon,
                  alt: 'Paper/pulp'
                }),
                'Paper/pulp'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { styleName: 'detail-icon-producers-wrap', xs: 4, sm: 2 },
                _react2.default.createElement('img', {
                  styleName: 'detail-icon-producers',
                  src: rbIcon,
                  alt: 'Rubber'
                }),
                'Rubber'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { styleName: 'detail-icon-producers-wrap', xs: 4, sm: 2 },
                _react2.default.createElement('img', {
                  styleName: 'detail-icon-producers',
                  src: tbIcon,
                  alt: 'Timber'
                }),
                'Timber'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { styleName: 'detail-icon-producers-wrap', xs: 4, sm: 2 },
                _react2.default.createElement('img', {
                  styleName: 'detail-icon-producers',
                  src: bfIcon,
                  alt: 'Cattle'
                }),
                'Cattle'
              ),
              _react2.default.createElement(
                _reactFlexboxGrid.Col,
                { styleName: 'detail-icon-producers-wrap', xs: 4, sm: 2 },
                _react2.default.createElement('img', {
                  styleName: 'detail-icon-producers',
                  src: syIcon,
                  alt: 'Soy'
                }),
                'Soy'
              )
            ),
            _react2.default.createElement(_components.ScreenedCompanies, null)
          )
        )
      );
    }
  }]);
  return DeforestationSectors;
}(_react.Component), _class2.propTypes = {}, _temp)) || _class);
exports.default = DeforestationSectors;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeforestationSectors/DeforestationSectors.js
// module id = 1305
// module chunks = 0